import {HttpContextToken} from '@angular/common/http';

export const HTTP_LOADING_FEATURE_KEY = 'http-loading';

/**
 *  A context token we can use to bypass the loading spinner for certain HTTP requests.
 *
 *  (One use case:  Autocomplete -- we don't want the loading spinner to interfere with the user when they are typing, so search requests for autocomplete
 *  should bypass our usual loading mechanism.)
 *
 *  See https://angular.io/guide/http-pass-metadata-to-interceptors.
 */
export const BYPASS_LOADING: HttpContextToken<boolean> = new HttpContextToken(() => false);

/**
 * A context token we can use to bypass our standard error handling mechanism for 400 errors (which is mostly displaying an error snack bar).
 */
export const BYPASS_400_ERROR: HttpContextToken<boolean> = new HttpContextToken(() => false);
